import { useMemo, useRef } from 'react';

export const createPickerSetting = ({
  name,
  observableName,
  rules,
  defaultValue,
  label,
  isFrom,
  getDisabledDate,
}) => {
  const result = {
    controllerProps: {
      name,
      defaultValue: defaultValue || null,
      rules,
    },
    watchProps: { name: observableName, exact: true },
  };

  if (label) {
    result.label = label;
  }

  if (typeof isFrom === 'boolean') {
    result.isFrom = isFrom;
  }

  if (typeof getDisabledDate === 'function') {
    result.getDisabledDate = getDisabledDate;
  }

  return result;
};

export const usePickerSettings = (startData, endData) => {
  const startGetDisabledDateRef = useRef(startData.getDisabledDate);
  startGetDisabledDateRef.current = startData.getDisabledDate;

  const endGetDisabledDateRef = useRef(endData.getDisabledDate);
  endGetDisabledDateRef.current = endData.getDisabledDate;

  const {
    name: startName,
    defaultValue: startDefaultValue,
    rules: startRules,
    label: startLabel,
  } = startData;
  const {
    name: endName,
    defaultValue: endDefaultValue,
    rules: endRules,
    label: endLabel,
  } = endData;

  return useMemo(() => {
    return [
      createPickerSetting({
        name: startName,
        defaultValue: startDefaultValue,
        rules: startRules,
        observableName: endName,
        label: startLabel,
        isFrom: true,
        getDisabledDate: startGetDisabledDateRef.current,
      }),
      createPickerSetting({
        name: endName,
        defaultValue: endDefaultValue,
        rules: endRules,
        observableName: startName,
        label: endLabel,
        getDisabledDate: endGetDisabledDateRef.current,
      }),
    ];
  }, [
    startName,
    startDefaultValue,
    startRules,
    endName,
    endDefaultValue,
    endRules,
    startLabel,
    endLabel,
  ]);
};
